import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import PrimaryLink from "../../elements/primary-link";
import Textarea from "../../elements/textarea";
import MyAccountTemplate from "../../sections/my-account-template";
import RadioButtonGroup from "../../elements/radio-button-group";
import "./style.scss";
import BodyText from "../../elements/body-text";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
// import { fieldsConflictMessage } from "graphql/validation/rules/OverlappingFieldsCanBeMerged";
import ConfirmationModal from "../../react-components/confirmation-modal";
import api from "../../utils/api";
import classNames from "classnames";

const MyAccoutDataAndPrivacy = ({ user, rendering, fields, lang }) => {
  const {
    hero,
    accountMenu,
    informationTitleType,
    informationTitleBody,
    informationBody,
    links,
    subjectsRightsRequestTitleType,
    subjectsRightsRequestTitleBody,
    subjectsRightsRequestBody,
    messagePlaceholder,
    messageInfoText,
    messageWarningMessage,
    messageSuccess,
    serverErrorMessage,
    ctaName,
    colorScheme,
    iconName,
    accessToDataLabel,
    forgetMeLabel,
    otherLabel,
    confirmationModal
  } = fields;

  const options = [
    { label: accessToDataLabel.value, value: "access to data" },
    { label: forgetMeLabel.value, value: "forget me" },
    { label: otherLabel.value, value: "other" }
  ];
  const [selectedRadioButtonOption, setSelectedRadioButton] = useState(options[0]);
  const [messageEntered, setMessageEntered] = useState("");
  const [hasError, setHasError] = useState(null);
  const [textAreaHasError, setTextAreaHasError] = useState();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  // const [localCountry, setLocalCountry] = useState(null);
  // const [preferLanguage, setPreferLanguage] = useState("");
  const [clearTextBox, setClearTextBox] = useState(false);
  const radioGroup = {
    selectedOption: selectedRadioButtonOption,
    options
  };

  const messageProps = {
    className: classNames(hasError ? "failed-message" : "success-message"),
    html: hasError ? serverErrorMessage.value : messageSuccess.value
  };
  const onTextAreaChange = evt => {
    setMessageEntered(evt.target.value);
  };

  const onRadioOptionChanged = selectedOption => {
    setSelectedRadioButton(selectedOption);
    if (selectedOption.value !== "other") {
      setTextAreaHasError(false);
    }
  };

  const onSubmitFormData = evt => {
    if (checkValidToSubmit()) {
      /*let data = {
        message: messageEntered,
        subjectsRightOption: selectedRadioButtonOption
      };*/
      setShowConfirmationModal(false);
      addCaseInfo();
    }
  };

  const checkValidToSubmit = () => {
    // if option other is selected it is mandatory to add a message to the request
    if (selectedRadioButtonOption) {
      if (selectedRadioButtonOption.value === "other" && (!messageEntered || messageEntered === "")) {
        setTextAreaHasError(true);
        return false;
      }
      return true;
    }
    return false;
  };

  const addCaseInfo = () => {
    api.caseInfo
      .add(null, {
        email: user.email,
        // country: localCountry,
        // preferLanguage: preferLanguage,
        subject: selectedRadioButtonOption.value,
        description: messageEntered
      })
      .then(res => {
        if (res.status !== 200) {
          setHasError(true);
          setClearTextBox(false);
        } else {
          setClearTextBox(true);
          setSelectedRadioButton(options[0]);
          setMessageEntered("");
          setHasError(false);
        }
      })
      .catch(res => {
        if (res.Status !== 200) {
          setHasError(true);
        } else {
          setHasError(false);
        }
        setClearTextBox(false);
      });
  };
  /*const getCountry = () => {
    api.site.get(null, { key: lang }).then(res => {
      setLocalCountry(res?.CountryLocal);
      setPreferLanguage(res?.CountryleadsLang);
    });
  };*/

  useEffect(() => {
    //getCountry();
  }, []);

  return (
    <>
      <MyAccountTemplate
        datasourceid={rendering.dataSource}
        heroConfiguration={
          hero[0].fields
            ? {
                ...hero[0].fields,
                titleBody: genrateHeadingWithFirstName(hero[0].fields.titleBody, user.firstName)
              }
            : {}
        }
        menu={accountMenu ? accountMenu[0].fields : {}}
      >
        <div className="my-account-data-and-privacy-content">
          <div className="my-account-data-and-privacy-section">
            <Heading type={informationTitleType} typographyClass="type-h3" html={informationTitleBody} />

            <BodyText className="my-account-data-and-privacy-section-body" html={informationBody.value} />
            {links.map(item => (
              <PrimaryLink key={item.fields.link.value.text} {...item.fields} />
            ))}
          </div>

          <div className="my-account-data-and-privacy-section">
            <Heading type={subjectsRightsRequestTitleType} typographyClass="type-h3" html={subjectsRightsRequestTitleBody} />

            <BodyText html={subjectsRightsRequestBody.value} className="my-account-data-and-privacy-section-body" />
            <div className="radio-group-container">
              <RadioButtonGroup
                {...{
                  ...radioGroup,
                  onChange: option => {
                    onRadioOptionChanged(option);
                    setHasError(null);
                  }
                }}
              />
            </div>
            <div className="my-account-data-and-privacy-section-textarea">
              <Textarea
                {...{
                  infoMessage: messageInfoText,
                  label: messagePlaceholder.value,
                  warningMessage: messageWarningMessage.value,
                  showError: textAreaHasError,
                  clearValue: clearTextBox,
                  onFocus: evt => setTextAreaHasError(false),
                  onChange: evt => {
                    onTextAreaChange(evt);
                    setHasError(null);
                  }
                }}
              />
            </div>

            {hasError !== null && <BodyText {...messageProps} />}

            <div className="my-account-data-and-privacy-section-button">
              <PrimaryButton
                {...{
                  colorScheme: colorScheme,
                  iconName: iconName,
                  link: {
                    value: {
                      text: ctaName.value
                    }
                  },
                  callback: evt => checkValidToSubmit() && setShowConfirmationModal(true)
                }}
              />
            </div>
          </div>
        </div>
      </MyAccountTemplate>
      <ConfirmationModal
        {...{
          heading: {
            type: confirmationModal.fields.headingType,
            html: confirmationModal.fields.headingBody
          },
          subHeading: {
            type: confirmationModal.fields.subheadingType,
            html: genrateHeadingWithFirstName(confirmationModal.fields.subheadingBody, user.email)
          },
          body: confirmationModal.fields.body.value,
          button: {
            ...{
              colorScheme: confirmationModal.fields.colorScheme,
              iconName: confirmationModal.fields.iconName,
              link: {
                value: {
                  text: confirmationModal.fields.ctaName.value
                }
              },
              callback: evt => onSubmitFormData(evt)
            }
          },
          showModal: showConfirmationModal,
          onCloseClicked: () => setShowConfirmationModal(false)
        }}
      />
    </>
  );
};

MyAccoutDataAndPrivacy.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    hero: PropTypes.object,
    accountMenu: PropTypes.object,
    informationTitleType: PropTypes.object,
    informationTitleBody: PropTypes.object,
    informationBody: PropTypes.shape({ value: PropTypes.string }),
    links: PropTypes.array,
    subjectsRightsRequestTitleType: PropTypes.object,
    subjectsRightsRequestTitleBody: PropTypes.object,
    subjectsRightsRequestBody: PropTypes.shape({ value: PropTypes.string }),
    messagePlaceholder: PropTypes.object,
    messageInfoText: PropTypes.shape({ value: PropTypes.string }),
    serverErrorMessage: PropTypes.object,
    ctaName: PropTypes.object,
    colorScheme: PropTypes.object,
    iconName: PropTypes.object
  })
};

const mapStateToProps = state => ({
  user: selectUserState(state)
});

export default connect(mapStateToProps)(MyAccoutDataAndPrivacy);
